<template>
  <div>
    <div class="head txt_center" :style="'background: url(' + bannerS +');background-size: cover;'">
       <span> {{ $t("FINANCIAL") }} </span> <br/>{{ $t("REWARDS") }}
    </div>
    <div class="widthBox">
        <el-row :gutter="10" class="acea-row row-between mg_-120 mb_80">
            <el-col :span="18" :xs="24">
                <video controls :src="video" class="img100 radius-8"></video>
            </el-col>
        </el-row>
        <p class="txt txt_center mb_24 f-28">{{ $t("YOU CONTROL YOUR DESTINY") }} </p>
        <p class="info3 f-14 txt_center mb_48">{{ $t("You can participate in the Jeunesse® Financial Rewards Plan at whichever level you wish. You decide whether you want to create a part-time income through retail sales or build a full-time business with dedicated teams all over the world. The Financial Rewards Plan offers you three categories of earning opportunities: customer sales, commissions from team building and rewards for your leadership.") }} </p>
        
        <el-row :gutter="10" class="acea-row row-between icons">
            <el-col :span="4" :xs="12" class="box">
                <div><img src="@/assets/icon_1.png" alt=""></div>
                <div>
                    <p class="txt">{{ $t("Customer Profit") }} </p>
                    <p class="warn_txt f-16">{{ $t("Retail Sales") }} </p>
                    <p class="warn_txt f-16">{{ $t("Customer Commissions") }} </p>
                    <p class="warn_txt f-16">{{ $t("Retail Sales Bonus") }} </p>
                </div>
            </el-col>
            <el-col :span="4" :xs="12" class="box">
                <div><img src="@/assets/icon_2.png" alt=""></div>
                <div>
                    <p class="txt">{{ $t("Customer Profit") }} </p>
                    <p class="warn_txt f-16">{{ $t("Team Commissions") }} </p>
                    <p class="warn_txt f-16">{{ $t("Matching Bonus") }} </p>
                    <p class="warn_txt f-16">{{ $t("Customer Acquisition Incentive") }} </p>
                </div>
            </el-col>
            <el-col :span="4" :xs="12" class="box">
                <div><img src="@/assets/icon_3.png" alt=""></div>
                <div>
                    <p class="txt">{{ $t("Customer Profit") }} </p>
                    <p class="warn_txt f-16">{{ $t("Diamond Bonus Pool") }} </p>
                    <p class="warn_txt f-16">{{ $t("Emerald Experience") }} </p>
                    <p class="warn_txt f-16">{{ $t("Diamond Discovery") }} </p>
                </div>
            </el-col>
        </el-row>
    </div>
    <div class="download mb_0" v-if="setting_list.financial_year_plan_url != '' || setting_list.ncome_disclosure_url != ''">
        <div v-if="setting_list.financial_year_plan_url != ''">
            <p class="info3 f-14 mb_12">{{ $t("Information herein is applicable in the United States.") }} </p>
            <p class="info3 f-14 mb_24">{{ $t("For complete details and definitions for the Jeunesse Financial Rewards Plan see the following") }}:</p>
            <div class="mb_48" style="padding: 12px 0;">
                            <!-- downloadFile -->
                <a :href="setting_list.financial_year_plan_url" download>
                    <img src="@/assets/download.png" style="width: 16px ;height: 16px;" alt="">
                    {{ $t("FIHANCIAL ALWAROS PLAN") }}
                </a>
            </div>
        </div>
        <div v-if="setting_list.ncome_disclosure_url != ''">
            <p class="info3 f-14 mb_12">{{ $t("Information herein is applicable in the United States.") }}</p>
            <p class="info3 f-14 mb_24">{{ $t("For details on typical earnings in the Jeunesse Financial Rewards Plan, see the Income Disclosures at the following") }}:</p>
            <div style="padding: 12px 0;">
                <a :href="setting_list.ncome_disclosure_url" download >
                    <img src="@/assets/download.png" style="width: 16px ;height: 16px;" alt="">
                    {{ $t("NCOME DISCLOSURES") }}
                </a>
            </div>
        </div>
    </div>
    <div class="banner mb_80">
        <img src="@/assets/img_2.png" class="img100" alt="">
    </div>
    <div class="widthBox mb_48" v-if="list.length != 0">
        <p class="f-40 warn_txt">{{list.length}} {{ $t("WAYS TO") }} </p>
        <p class="f-72 mb_24">{{ $t("EARN") }}</p>
        <p class="info3 f-14">{{ $t("The Jeunesse Financial Rewards Plan is one of the most competitive compensation plans in the industry. Our Distributors are able to generate income in six different ways, earn luxury travel rewards and climb 15 prestigious achievement ranks.") }}</p>
    </div>
    <div v-for="(item,index) in list" :key="index" class="pd_bt_40" :class="(index + 2)%2 == 0 ? 'bg_f5' : ''">
        <div class="widthBox">
            <el-row :gutter="30" class="acea-row row-between">
                <el-col :span="12" :xs="24">
                    <div class="name mb_40"> <span>{{ index+1 }}</span> {{ item.name }}</div>
                    <div v-for="(item2,index2) in item.instruction_list" :key="index2" :class="(index2+1) != item.instruction_list.length ? 'mb_24' :'mb_00'">
                        <div class="txt mb_8">{{ item2.name
 }}</div>
                        <div class="info3 f-14">1221{{ item2.value }}</div>
                    </div>
                </el-col>
                <el-col :span="12" :xs="24">
                    <img :src="item.image_url_list[0]" class="img100" alt="">
                </el-col>
            </el-row>
        </div>
    </div>
    <div class="mt_80">
            <el-row :gutter="10" class="acea-row row-between">
                <el-col :span="14" :xs="24" class="txt_center">
                    <p class="info3 f-14 mb_24">{{$t("Second knot, issued every week, explosive best-selling more than 10 countries in the world, all are your market. Truly global village, a mobile phone, a website to do global business.")}} </p>
                    <p class="info f-20 mb_16">{{$t("Are you ready to get your reward?")}}</p>
                    <div class="btn mb_24">
                        <a target="_blank" href="http://phromonglobal.com">{{$t("Join us and start earning rewards")}}</a>
                    </div>
                    <p class="info f-20 mb_16 hidden-xs-only">{{ $t("Contact Us") }}</p>
                    <ul style="width: 50%;text-align: left;margin: 0 auto;" class="hidden-xs-only">
                        <li>{{ $t("Enterprise email") }} ：{{ contact_us_info.products_after_sales_email }}</li>
                        <li>{{ $t("Products after-sales email") }}：{{ contact_us_info.enterprise_email }}</li>
                        <li>{{ $t("Member support email") }}：{{ contact_us_info.member_support_email }} </li>
                    </ul>
                    <div class="hidden-sm-and-up" style="margin-top: 24px;">
                        <div class="info2">
                            {{ $t("Got a problem? Contact us") }}
                            <img src="@/assets/phone.png" style="width: 16px;height: 16px; vertical-align: top;" alt="">
                            <span style="font-size: 12px;color: #40B4E5;">123-456-789</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
    </div>
  </div>
</template>

<script>
export default {
    name:"FinancialRewards",
    data(){
        return {
            setting_list:[],
            list:[]
        }
    },
		created(){
			this.get_info()
		},
    mounted(){
			document.body.scrollIntoView();
    },
    computed: {
        video() {
            return this.$store.state.video
        },
        bannerS() {
            return this.$store.state.bannerS
        },
        bannerS() {
            return this.$store.state.bannerS
        },
        contact_us_info(){
            return this.$store.state.contact_us_info
        }
    },
		methods:{
			async get_info(){
			    let res = await this.$api.get("api/MemberCenter/financialRewards", this.query);
					this.setting_list = res.data.setting_list
					this.list = res.data.way_list || []
					console.log(this.list)
			},
			downloadFile(fileName) {
				const fileUrl = '/path/to/' + fileName; // 文件的URL地址
				window.open(fileUrl);
			}
		}
}
</script>

<style lang="scss" scoped="scoped">
.head{
    font-size: 80px;
    span{
        font-size: 56px;
    }
    background: rgba($color: #000000, $alpha: 0.2);
    padding-top: 40px;
    padding-bottom: 220px;
    color: #fff;
}
.bg_f5{
    background: #f5f5f5;
}
.btn{
    padding: 12px 24px;
    // background: #B50900;
    a{
        padding: 12px 24px;
        background: #B50900;
        color: #Fff;
        font-size: 14px;
        border-radius: 8px;
    }
}
.mb_8{
    margin-bottom: 8px;
}
.mb_16{
    margin-bottom: 16px;
}
.mb_40{
    margin-bottom: 40px;
}
.mt_80{
    margin-top: 80px;
}
.pd_bt_40{
    padding-top: 40px;
    padding-bottom: 40px;
}
.mb_00{
    margin-bottom: 0px;
}
.f-72{
    font-size: 72px;
    color: #1a1a1a;
}
.f-40{
    font-size: 40px;
}
.mg_-120{
    margin-top: -220px;
}
.mb_80{
    margin-bottom: 80px;
}
.mb_48{
    margin-bottom: 48px;
}
.mb_12{
    margin-bottom: 12px;
}
.mb_24{
    margin-bottom: 24px;
}
    .mb_0 {
        margin-bottom: 0px;
    }
.icons{
    .box{
        text-align: center;
        margin-bottom: 24px;
        img{
            margin-bottom: 24px;
        }
        p{
            margin-bottom: 12px;
        }
    }
}
.name{
    font-size: 28px;
    color: #40B4E5;
    display: flex;
    align-items: center;
    span{
        color: #fff;
        font-size: 20px;
        padding: 7px 15px;
        background: #40B4E5;
        margin-right: 16px;
    }
}
ul li{
    list-style: disc;
    color: #666666;
    font-size: 14px;
    position: relative;
    left: 14px;
    margin-bottom: 12px;
}
.download{
    padding: 40px;
    background: #f5f5f5;
    text-align: center;
    a{
        color: #40B4E5;
        border: 1px solid#40B4E5;
        padding: 12px 24px;
        border-radius: 8px;
        img{
        vertical-align: top;
        }
    }
		.down{
			display: inline-block;
			color: #40B4E5;
			border: 1px solid#40B4E5;
			padding: 12px 24px;
			border-radius: 8px;
			img{
			vertical-align: top;
			}
		}
}
@media screen and(max-width:768px) {
    .btn a{
        
        display: block;
    }
.mt_80{
    margin-top: 32px;
}
    .head{
        font-size: 28px;
        span{
            font-size: 20px;
        }
        background: rgba($color: #000000, $alpha: 0.2);
        padding-top: 32px;
        padding-bottom: 20px;
    }
    .mb_48{
        margin-bottom: 40px;
    }
    .mb_24 {
        margin-bottom: 12px;
    }
    .mb_80 {
        margin-bottom: 24px;
    }
    .mb_0 {
        margin-bottom: 56px;
    }
    .f-72{
        font-size: 28px;
        color: #4D4D4D;
    }
    .f-40{
        font-size: 14px;
    }
    .mb_00{
        margin-bottom: 16px;
    }
    .mg_-120{
        margin-top: -20px;
    }
    .icons{
        .box{
            img{
                margin-bottom: 12px;
            }
            p{
                margin-bottom: 8px;
            }
        }
    }
    
    .pd_bt_40{
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .mb_40{
        margin-bottom: 16px;
    }
    .mb_8{
        margin-bottom: 12px;
        }
    .name{
        font-size: 20px;
        span{
            font-size: 14px;
            padding: 3px 8px;
        }
    }
    .txt{
        font-size: 14px;
    }
}

</style>